/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Meta, Meta$inboundSchema } from "./meta.js";
import { Pagination, Pagination$inboundSchema } from "./pagination.js";
import {
  V1ApiKeysListKeysResponseData,
  V1ApiKeysListKeysResponseData$inboundSchema,
} from "./v1apikeyslistkeysresponsedata.js";

export type V1ApiKeysListKeysResponseBody = {
  /**
   * Metadata object included in every API response. This provides context about the request and is essential for debugging, audit trails, and support inquiries. The `requestId` is particularly important when troubleshooting issues with the Teral support team.
   */
  meta: Meta;
  data: Array<V1ApiKeysListKeysResponseData>;
  /**
   * Pagination metadata for list endpoints. Provides information necessary to traverse through large result sets efficiently using cursor-based pagination.
   */
  pagination: Pagination;
};

/** @internal */
export const V1ApiKeysListKeysResponseBody$inboundSchema: z.ZodType<
  V1ApiKeysListKeysResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  meta: Meta$inboundSchema,
  data: z.array(V1ApiKeysListKeysResponseData$inboundSchema),
  pagination: Pagination$inboundSchema,
});

export function v1ApiKeysListKeysResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<V1ApiKeysListKeysResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => V1ApiKeysListKeysResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1ApiKeysListKeysResponseBody' from JSON`,
  );
}
